import { render, staticRenderFns } from "./LogoTournament.vue?vue&type=template&id=466f8944"
import script from "./LogoTournament.vue?vue&type=script&lang=js"
export * from "./LogoTournament.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports